<!--
Author: TangChen
Date: 2018-09-27
Desc: 账户绑定组件
 -->
<template>
    <div class="comp-bind-acct-dc comp">
        <div class="acct-con bizcomp-border">
            <step :navs="navs" />
            <div class="check-acct">
                <!-- 验证证件信息   label-width="260px" -->
                <el-form
                    v-if="!checked"
                    ref="pwdForm"
                    :model="pwdForm"
                    :rules="rules"
                    label-width="110px"
                    class="pwdForm"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <divide-title
                        v-if="!hasTranAcct"
                        :line-style="{ 'margin-left': '30px' }"
                        title="证件信息"
                        tip="根据监管要求，交易前需上传本人身份证照片，信息仅用于身份验证。请准备好身份证照片和银行卡(建议使用一类账户)。"
                    ></divide-title>
                    <el-row>
                        <el-col class="el-row-common" :span="24">
                            <el-form-item
                                label="开户证件："
                                prop="certType"
                                class="cert-types-line"
                            >
                                <el-select
                                    v-model="pwdForm.certType"
                                    placeholder="请选择证件类型"
                                    :style="{ width: btnStyle }"
                                    :disabled="true"
                                    v-on:change="checkCertNoAgain"
                                >
                                    <el-option
                                        v-for="item in certTypes"
                                        :key="item.subitem"
                                        :label="item.subitemname"
                                        :value="item.subitem"
                                    />
                                </el-select>
                                <el-button
                                    v-show="ocrUpdBtnS"
                                    :disabled="ocrDis"
                                    type="primary"
                                    v-on:click="ocrShow = true"
                                >
                                    {{ ocrBtnText }}
                                </el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div v-if="ocrUpdBtnS" class="ocrTip">
                        证件信息识别结果如下，如有错误，请重新上传
                    </div>
                    <el-row>
                        <el-col class="el-row-common" :span="11">
                            <el-form-item v-if="!hasTranAcct" label="开户姓名：" prop="userName">
                                <el-input
                                    v-model.trim="pwdForm.userName"
                                    :placeholder="
                                        ocrUpdBtnS
                                            ? '上传证件后自动回填'
                                            : '请' + holderText + '真实姓名'
                                    "
                                    :maxlength="20"
                                    :disabled="dis || dateSet.dis"
                                />
                            </el-form-item>
                            <el-form-item label="证件号码：" prop="certNo">
                                <el-input
                                    v-model.trim="pwdForm.certNo"
                                    :placeholder="
                                        ocrUpdBtnS
                                            ? '上传证件后自动回填'
                                            : '请' + holderText + '证件号码'
                                    "
                                    :maxlength="20"
                                    :disabled="dis || dateSet.dis"
                                    v-on:blur="initBirthdate"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="13">
                            <el-form-item v-if="!hasTranAcct" label="证件有效期：" prop="vailddate">
                                <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                            </el-form-item>
                            <el-form-item
                                v-if="!hasTranAcct"
                                label="出生日期："
                                prop="birthdate"
                                class="birthdate-select"
                            >
                                <date-picker
                                    :date="dateSetBirth"
                                    v-on:date-get="dateInterval_birth"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div v-if="!hasTranAcct" class="cut-off-line top"></div>
                    <divide-title title="银行卡信息" :line-style="{ 'margin-left': '30px' }" />
                    <el-row class="bank-info">
                        <el-form-item
                            v-if="!hasTranAcct"
                            label="所属银行："
                            prop="bankType"
                            class="bank"
                        >
                            <div
                                class="bank-msg"
                                :style="{ opacity: bankInfo.channelid ? 1 : 0 }"
                                v-on:click.prevent="showBank"
                            >
                                <div
                                    v-if="bankInfo.channelid"
                                    class="bank-img-sel clear"
                                    :class="{ 'bg-w': bankInfo.channelid }"
                                >
                                    <img
                                        :src="$util.getImg(bankInfo.bankcode)"
                                        title="bank-img"
                                        alt=""
                                    />
                                    <span class="k-text-flow">
                                        {{
                                            bankInfo.bankname.toString().substr(0, 10) +
                                            (bankInfo.bankname.toString().length > 10 ? "..." : "")
                                        }}
                                    </span>
                                    <i class="paycenter" aria-hidden="true">
                                        {{ bankInfo.paycentername.substr(0, 4) }}
                                    </i>
                                </div>
                            </div>
                            <el-input
                                v-model.trim="pwdForm.bankType"
                                placeholder="请选择所属银行"
                                :maxlength="20"
                                suffix-icon="fa fa-money-check"
                            />
                        </el-form-item>
                    </el-row>
                    <el-row class="form-row-bankInfo">
                        <el-form-item
                            v-if="bankInfo.isneedbank === '1'"
                            label="开户行所在省："
                            prop="bankprovince"
                            class="required form-bankInfo"
                        >
                            <el-select
                                v-model="pwdForm.bankprovince"
                                filterable
                                placeholder="请选择开户行所在省"
                            >
                                <el-option
                                    v-for="item in bankprovince"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            v-if="bankInfo.isneedbank === '1' && pwdForm.bankprovince !== ''"
                            label="开户行所在城市："
                            prop="city"
                            class="required form-bankInfo"
                        >
                            <el-select
                                v-model="pwdForm.city"
                                filterable
                                placeholder="请选择开户行所在城市"
                            >
                                <el-option
                                    v-for="item in city"
                                    :key="item.cityid"
                                    :label="item.cityname"
                                    :value="item.cityid"
                                />
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row class="bank-info">
                        <el-form-item
                            v-if="bankInfo.isneedbank === '1' && pwdForm.city !== ''"
                            label="开户行名称："
                            prop="bankname"
                            class="required"
                        >
                            <el-autocomplete
                                v-model.trim="pwdForm.bankname"
                                class="inline-input"
                                :fetch-suggestions="querySearch"
                                placeholder="请输入开户行名称"
                                :maxlength="40"
                                v-on:blur="checkBankName"
                            >
                                <el-tooltip
                                    slot="suffix"
                                    class="item"
                                    effect="info"
                                    :content="infoText"
                                    placement="top"
                                >
                                    <el-button class="info-btn">
                                        <i class="el-icon-question" aria-hidden="true" />
                                    </el-button>
                                </el-tooltip>
                            </el-autocomplete>
                        </el-form-item>

                        <el-form-item v-if="!hasTranAcct" label="银行卡号码：" prop="bankNo">
                            <div
                                class="bank-code el-message--warning"
                                :class="{ show: showBankCard && pwdForm.bankNo !== '' }"
                            >
                                {{ $util.getNewCard(pwdForm.bankNo) }}
                            </div>
                            <el-input
                                v-model.trim="pwdForm.bankNo"
                                placeholder="请输入银行卡号码"
                                :maxlength="20"
                                v-on:focus="showBankCard = true"
                                v-on:blur="showBankCard = false"
                            />
                        </el-form-item>
                    </el-row>
                    <el-row class="form-row-mobile">
                        <el-form-item
                            v-if="!hasTranAcct"
                            label="银行预留手机号码："
                            class="form-mobile"
                            prop="mobile"
                            :class="{ 'form-text': !(bankInfo && bankInfo.identifytype === '1') }"
                        >
                            <el-input
                                v-model.trim="pwdForm.mobile"
                                placeholder="请输入银行预留手机号码"
                                :maxlength="11"
                            />
                        </el-form-item>
                    </el-row>
                    <el-row class="bank-btn">
                        <el-form-item>
                            <div>
                                <el-button class="medium dc-cancel-btn" v-on:click="backPage">
                                    取消
                                </el-button>
                                <el-button type="primary" class="medium" v-on:click="mobileCheck">
                                    提交
                                </el-button>
                            </div>
                        </el-form-item>
                        <el-form-item v-if="openTran" label="" class="form-text">
                            <div class="step-info error">
                                <span>{{ openTran + "，无法进行绑定。" }}</span>
                                <span
                                    v-if="openTran.indexOf('开户') > -1"
                                    class="info-btn"
                                    v-on:click.prevent="$router.push({ name: 'bindnewacct' })"
                                >
                                    立即开立交易账号
                                </span>
                            </div>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 验证交易密码 -->
                <el-form
                    v-if="checkTPwd"
                    ref="acctInfo"
                    :model="acctInfo"
                    :rules="rules"
                    label-width="260px"
                    class="pwdForm"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <el-form-item label="姓名：" class="form-text">
                        <div class="text-con">
                            {{ acctInfo.name }}
                        </div>
                    </el-form-item>
                    <el-form-item label="证件号码：" class="form-text">
                        <div class="text-con">
                            {{ acctInfo.certNo }}
                        </div>
                    </el-form-item>
                    <el-form-item label="交易密码：" prop="pwd">
                        <el-input
                            v-model.trim="acctInfo.pwd"
                            :type="pwdType"
                            placeholder="请输入以上交易账号对应的交易密码"
                            :maxlength="16"
                        >
                            <i
                                slot="suffix"
                                aria-hidden="true"
                                :class="iconCla"
                                v-on:click="pwdTypeChange"
                            />
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <div style="width: 50%">
                            <el-button
                                type="primary"
                                class="medium"
                                v-on:click="submitInfo('acctInfo')"
                            >
                                下一步
                            </el-button>
                            <el-button class="medium" v-on:click="returnCheck()">返回</el-button>
                        </div>
                    </el-form-item>
                </el-form>
                <!-- 开户信息 -->
                <div v-if="opentAcct">
                    <open-acct
                        :data="openPar"
                        :crm-cust-info="crmCustInfo"
                        v-on:get-acct="getAcct"
                    />
                </div>
            </div>
            <div v-if="bindResult" class="open-acct-result">
                <div class="result-contain">
                    <div class="result-img-contain">
                        <img src="../../assets/img/success.png" alt="" />
                    </div>
                    <div class="result-text">
                        恭喜您！{{ $const.COMPANY }}基金网上交易账户开户成功！
                    </div>
                    <div class="res-text">去开启购基之旅吧！</div>
                </div>
                <div class="result-confirm-contain">
                    <el-button
                        type="primary"
                        class="medium"
                        v-on:click="$router.push({ name: 'risk' })"
                    >
                        前往风险测评
                    </el-button>
                </div>
            </div>
            <bank-lists-dc :bank-visible="bankVisible" v-on:bank-hide="getBankMsg" />
            <agreement v-model="protocol" :data="agrType" v-on:all-read="agreePro"></agreement>
            <mobile-code
                :mobile-visible="mobileVisible"
                :mobile-no="pwdForm.mobile"
                v-on:verify-in="verifyMobileCode"
            />
            <img-code :dialog-visible="dialogVisible" v-on:verify-in="getVerifyCode" />
            <ocr-upd-dialog
                :visible="ocrShow"
                :formdatas="pwdForm"
                v-on="{ success: imgUp, back: regression }"
            />
        </div>
        <footer-questions
            class="footer-questions"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footer-questions>
    </div>
</template>
<script>
import bankListsDc from "@/components/form/bankListsDc.vue";
import openAcct from "@/components/form/openAcctDc.vue";
import step from "@/components/layout/step.vue";
import agreement from "@/components/form/agreement.vue";
import ocrUpdDialog from "@/components/form/ocrUpdDialog.vue";
import datePicker from "@/components/form/datePicker.vue";
import divideTitle from "@/components/form/divideTitle";
import format from "date-fns/format";
import imgCode from "@/components/layout/imgCode.vue";
import mobileCode from "@/components/layout/mobileCodeDc.vue";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import userApi from "@/api/user";

export default {
    name: "BindAcct",
    components: {
        bankListsDc,
        openAcct,
        mobileCode,
        agreement,
        ocrUpdDialog,
        datePicker,
        imgCode,
        divideTitle,
        step,
        footerQuestions
    },
    props: {
        way: Boolean
    },
    data() {
        return {
            dialogVisible: false,
            mobileVisible: false,
            ocrVisible: false,
            showBankCard: false, // 是否着重显示银行卡号码
            agrType: "add", // 协议类型，增卡协议
            time: 0, // 验证码再次发送间隔
            countrycode: [], // 国家码
            machinecode: [], // 座机地区码
            natural: [], // 自然人标识
            profession: [],
            pwdForm: {
                // 表单参数配置
                userName: "",
                certType: "",
                certNo: "",
                vailddate: "",
                bankType: "",
                bankNo: "",
                mobile: "",
                verifyCode: "",
                birthdate: "",
                address: "",
                bankprovince: "",
                city: "",
                bankname: ""
            },
            setInfoFlag: "1", // 纯代销注册状态标示
            protocol: false,
            pwdType: "password",
            iconCla: "fa fa-eye-slash",
            acctInfo: {
                // 交易账户信息
                name: "",
                certNo: "",
                pwd: "",
                hkopenflag: ""
            },
            dis: false,
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "",
                btnL: {
                    text: "返回首页",
                    event: "login-now"
                },
                btnR: {
                    ctd: "秒后自动跳转用户中心",
                    time: 10,
                    event: "return-login"
                }
            },
            bindResult: false, // 是否显示绑定结果页
            bankVisible: false, // 是否弹出银行卡列表
            checked: false, // 手机或银行卡校验是否通过 //todo
            navs: [{ val: "身份验证", active: true }, { val: "补充信息" }, { val: "开户结果" }], // 导航栏配置
            certTypes: [], // 证件类型
            openTran: "", // 重新开立交易账户提示信息
            btnMsg: "获取短信验证码",
            hasTranAcct: false, // 是否有交易账号
            locked: false, // 是否已发送短信验证码
            bankInfo: {},
            checkTPwd: false, // 显示验证交易密码页面
            opentAcct: false, // todo
            openPar: { isBranch: "1" },
            rules: {
                // 校验规则
                userName: [{ validator: this.checkName, trigger: "blur" }],
                certType: [{ required: true, message: "请选择证件类型", trigger: "change" }],
                certNo: [
                    //                        {required: true, message: "请输入证件号码", trigger: "blur"},
                    { validator: this.checkCertNo, trigger: "blur" }
                ],
                vailddate: [
                    { validator: this.checkVailddate, trigger: "blur" }
                    //                        {required: true, message: "请选择证件有效期", trigger: "blur"}
                ],
                birthdate: [
                    { validator: this.checkBirthdate, trigger: "blur" }
                    //                        {required: true, message: "请选择出生日期", trigger: "blur"}
                ],
                bankType: [{ required: true, message: "请选择所属银行", trigger: "blur" }],
                pwd: [{ required: true, message: "请输入绑定账号的交易密码", trigger: "blur" }],
                bankNo: [
                    { required: true, message: "请输入银行卡号码", trigger: "blur" },
                    { validator: this.$util.validateBankNum, trigger: "blur" }
                ],
                mobile: [
                    { required: true, message: "请输入银行预留手机号码", trigger: "blur" },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                verifyCode: [{ validator: this.$util.validateVerifyCode, trigger: "blur" }],
                bankprovince: [{ required: true, message: "请选择开户省", trigger: "change" }],
                city: [{ required: true, message: "请选择开户城市", trigger: "change" }],
                bankname: [
                    { required: true, message: "请选择开户行名称", trigger: "change" },
                    { validator: this.$util.validateBankName, trigger: "change" }
                ]
            },
            ocrBtnText: "上传证件照",
            ocrShow: false,
            isIE9: false,
            ocrEnable: false,
            ocrUpdBtnS: false,
            hasOcr: "0",
            dateSet: { type: "3", max: "", dis: false, val: "", text: "请选择证件有效期" },
            dateSetBirth: { type: "1", max: "", dis: true, val: "", text: "请选择出生日期" },
            btnStyle: "50%",
            holderText: "输入",
            ocrupdflag: "0", // 上传成功标示
            randomToken: "",
            commonQuestion: [
                {
                    title: "使用农行卡开户、重置密码或换卡，跳转至银行页面后为何显示找不到请求记录？",
                    answer: "",
                    showFlag: false
                },
                {
                    title: "使用交行卡快捷开户或重置密码时，跳转至银联页面时提示未开通服务？",
                    answer: "",
                    showFlag: false
                },
                {
                    title: "使用浦发磁条卡开户或重置密码时，跳转到银联页面时提示未开通服务？",
                    answer: "",
                    showFlag: false
                }
            ],
            warningHtml: "",
            infoText: "如果下拉选项中及搜索结果中没有您的开户行，请选择附近的开户行",
            bankprovince: [], // 省
            city: [], // 城市
            country: [],
            branchList: [], // 支行列表
            query: null, // 定时查找
            crmCustInfo: {}
        };
    },
    computed: {
        ocrDis: function () {
            return !(
                (this.pwdForm.certNo &&
                    (!this.hasTranAcct ? this.pwdForm.userName : true) &&
                    this.pwdForm.vailddate &&
                    this.pwdForm.birthdate) ||
                this.pwdForm.certType == "00"
            );
        }
    },
    watch: {
        hasTranAcct(val) {
            this.returnCheck();
        },
        "pwdForm.certType"(val) {
            if (val === "00") {
                this.dateSetBirth.dis = true;
                this.ocrUpdBtnS = this.ocrEnable;
                this.dateSet.dis = this.ocrEnable;
            } else {
                this.dateSetBirth.dis = false;
                this.ocrUpdBtnS = false;
                this.dateSet.dis = false;
            }
            if (val === "05") {
                this.dateSetBirth.dis = true;
            }
            if (this.setInfoFlag === "0") {
                this.setInfoFlag = "1";
                return false;
            }
            if (this.ocrUpdBtnS === true) {
                // this.dateSet.dis = (val == "00" && this.hasOcr == "1") ? true : false;
                // this.dateSetBirth.dis = (val == "00" && this.hasOcr == "1") ? true : false;
            }
            this.pwdForm.userName = "";
            this.pwdForm.certNo = "";
            this.pwdForm.vailddate = "";
            this.pwdForm.birthdate = "";
            this.pwdForm.address = "";
            this.ocrupdflag = "0";
            this.$set(this.dateSet, "val", "");
            this.$set(this.dateSet, "time", new Date().getTime());
            this.$set(this.dateSetBirth, "val", "");
            this.$set(this.dateSetBirth, "time", new Date().getTime());
            this.$refs.pwdForm.clearValidate();
        },
        "dateSet.dis"(val) {
            this.holderText = val == true ? "上传证件后自动回填" : "输入";
            this.$set(
                this.dateSet,
                "text",
                val == true ? "上传证件后自动回填" : "请选择证件有效期"
            );
            this.$set(
                this.dateSetBirth,
                "text",
                val == true ? "上传证件后自动回填" : "请选择出生日期"
            );
        },
        "pwdForm.bankprovince"(val) {
            // 城市查询
            const _p = this.bankprovince.find((item) => {
                return item.subitem === val;
            });
            this.pwdForm.city = "";
            this.$util.getCity(_p.subitem, (data) => {
                this.city = data || [];
                if (!this.pwdForm.city || !this.matched()) {
                    this.$set(this.pwdForm, "city", this.city[0].cityid || "");
                }
            });
        },
        "pwdForm.city"() {
            this.pwdForm.bankname = "";
        }
    },
    created() {
        this.bankprovince = this.$cache.getDict("190021");
        this.country = this.$util.changeArrIndex(this.$cache.getDict("120109"), "CN");
        this.countrycode = this.$cache.getDict("150136");
        this.machinecode = this.$cache.getDict("150137");
        this.natural = this.$cache.getDict("120200");
        this.profession = this.$cache.getDict("150141");
        this.certTypes = this.$cache.getDict("130007");
        let findIndex = this.certTypes.findIndex((item) => item.subitem === `00`);
        if (findIndex >= 0) {
            this.certTypes[findIndex].subitemname = `身份证`;
        }
        const conf = this.$util.getConfig().const;
        const birthmax = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
        this.dateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.dateSetBirth.max = this.$util.fmtDate(birthmax);
        this.dateSetBirth.min = this.$util.fmtDate("19000101");
        if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
            this.isIE9 = true;
        }
        this.warningHtml = `<p>1、亲爱的中银易商用户，请下载${
            this.$const.COMPANY
        }基金APP完成相关操作，官网、微信不支持该项目服务，给您带来的不便深表歉意。您可以拨打${
            this.$const.COMPANY
        }基金客服热线  <span style="color:red;">${this.$cache.getCompanyInfoParam(
            "10101009"
        )}</span>  进行咨询。</p>
                            <p class="mt5">2、如果您的支付银行卡为民生银行，无法自助找回交易密码，请联系客服  <span style="color:red;">${this.$cache.getCompanyInfoParam(
                                "10101009"
                            )}</span>  找回。</p>`;
        this.bindWay(this.way);
        if (!this.hasTranAcct) {
            this.getOcrOpenStatus();
        }
        this.pwdForm.certType = "00";
        this.getCrmCustInfo();
    },
    methods: {
        dialogClose() {
            this.ocrShow = false;
        },
        getVerifyCode(val) {
            this.dialogVisible = false;
            if (val) {
                this.sendBank(val);
            }
        },
        /* 回退到鉴权界面 */
        returnCheck() {
            this.checked = false;
            this.locked = false;
            this.checkTPwd = false;
            this.opentAcct = false;
            this.openTran = "";
            this.bindWay(this.hasTranAcct);
        },
        // 改变证件类型再次校验证件号码
        checkCertNoAgain() {
            this.pwdForm.userName = "";
            this.pwdForm.certNo = "";
            this.pwdForm.vailddate = "";
            this.pwdForm.birthdate = "";
            this.pwdForm.address = "";
            this.ocrupdflag = "0";
            this.$refs.pwdForm.validateField(["userName", "certNo", "vailddate", "birthdate"]);
        },
        agreePro(val) {
            this.protocol = false;
            if (!val) return;
            if (this.bankInfo.identifytype === "1") {
                this.mobileVisible = true;
            } else {
                this.sendBank();
            }
        },
        // 获取用户信息
        async getAcct(val) {
            if (!val) {
                return this.returnCheck();
            }
            // 获取用户性别
            let sexVal = "";
            if (this.pwdForm.certType === "00") {
                sexVal = this.getSex(this.pwdForm.certNo);
            } else {
                sexVal = val.sex;
            }
            const info = this.$cache.getUser();
            let _x = {
                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo,
                depositcard: this.pwdForm.bankNo,
                channelid: this.bankInfo.channelid,
                channelname: this.bankInfo.channelname,
                depositname: this.pwdForm.userName,
                paychannel: this.bankInfo.paycenterid,
                bankcode: this.bankInfo.bankcode,
                custname: this.pwdForm.userName, // 客户名称
                validdate: this.pwdForm.vailddate, // 证件有效期
                validtype: this.getvalidtype(this.pwdForm.vailddate),
                birthday: this.pwdForm.birthdate,
                bankprovince: this.pwdForm.bankprovince,
                bankcity: this.pwdForm.city,
                bankname: this.pwdForm.bankname,

                mobilenocycode: "86",
                tradepwd: this.$util.enc(val.pwd),
                tradepassword: this.$util.enc(val.pwd),
                delivertype: val.delivertype,
                deliverway: val.deliverway,
                cardtelno: this.pwdForm.mobile,
                mobileno: info.mobileno || this.pwdForm.mobile,
                email: val.email,
                address: val.address, //
                telcycode: val.telnocycode,
                telareacode: val.telnoareacode,
                telno: val.telno,
                fax: val.fax,
                faxcycode: val.faxcycode,
                faxareacode: val.faxareacode,
                postcode: val.postcode,
                sex: sexVal,

                hkopenflag: this.acctInfo.hkopenflag,
                assetssource: val.assetssource,
                country: val.country,
                otherprovince: val.otherprovince,
                isdigniaryorceo: val.isdigniaryorceo,
                belongregion: val.belongregion,
                location: val.location,
                livingcountry: val.cncountry,
                branchnum: val.branchcode,
                birthdate: this.pwdForm.birthdate,
                beneficiary: val.beneficiary,
                beneficiarytype: val.beneficiarytype,
                beneficiaryno: val.beneficiaryno,
                beneficiarydate: val.beneficiarydate,
                benefitvalidtype: this.getvalidtype(val.beneficiarydate),
                beneficiarysex: val.beneficiarysex,
                beneficiarybirthday: val.beneficiarybirthday,
                occupation: val.occupation,
                vocationsupple: val.vocationsupple,
                livingaddressprovince: val.cnprovince,
                livingaddresscity: val.cncity,
                livingaddresscounty: val.cncounty,
                livingaddress: val.address,
                province: val.cnprovince,
                city: val.cncity,
                county: val.cncounty,
                exempttype: "0", // 税收声明豁免必传，默认传0-不豁免
                specialpersonflag: val.natural,
                educationlevel: val.educationlevel,
                addresscity: val.cncity,
                addresscounty: val.county,
                beneficiarycountry: val.beneficiarycountry, // 受益人国家
                beneficiaryaddrprovince: val.beneficiaryaddrprovince, //  受益人省
                beneficiaryaddrcity: val.beneficiaryaddrcity, // 受益人城市
                beneficiaryaddrcounty: val.beneficiaryaddrcounty, // 受益人县
                beneficiaryemail: val.beneficiaryemail, // 受益人邮箱
                beneficiarypostcode: val.beneficiarypostcode, // 受益人邮编
                benefisself: val.benefisself, // 受益人是否是本人
                beneficiaryvocation: val.beneficiaryvocation, // 受益人职业
                beneficiarytelnocycode: val.beneficiarytelnocycode, // 国家码
                beneficiarytelnoareacode: val.beneficiarytelnoareacode, // 国家码
                beneficiarytelno: val.beneficiarytelno, // 手机号
                beneficiaryaddr: val.beneficiaryaddr, // 受益人详细地址
                benefrelation: val.benefrelation,
                actualctrladdr: val.actualctrladdr, // 控制人
                actualctrladdrcity: val.actualctrladdrcity,
                actualctrladdrcounty: val.actualctrladdrcounty,
                actualctrladdrprovince: val.actualctrladdrprovince,
                actualctrlbirthday: val.actualctrlbirthday,
                actualctrlcountry: val.actualctrlcountry,
                actualctrlemail: val.actualctrlemail,
                actualctrlidcode: val.actualctrlidcode,
                actualctrlidtype: val.actualctrlidtype,
                actualctrlname: val.actualctrlname,
                actualctrlpostcode: val.actualctrlpostcode,
                actualctrlsex: val.actualctrlsex,
                actualctrltelno: val.actualctrltelno,
                actualctrltelnocycode: val.actualctrltelnocycode,
                actualctrltelnoareacode: val.actualctrltelnoareacode,
                actualctrlvalidate: val.actualctrlvalidate,
                actualctrlvalitype: this.getvalidtype(val.actualctrlvalidate),
                actualctrlvocation: val.actualctrlvocation,
                actualisself: val.actualisself,
                actualrelation: val.actualrelation,
                annualincome: val.annualincome,
                nonresiflag: val.nonresiflag,
                custtag: "0"
            };
            if (val.nonresiflag !== "0") {
                _x = {
                    ..._x,
                    ...val.crsInfo
                };
            }
            const accRistRes = await userApi.acctRiskListManage({
                invtp: `1`,
                opaction: "Q",
                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo
            });
            if (accRistRes.data.length > 0) {
                this.$message.warning("账号为风险客户，请联系客服进行开户操作!");
                return false;
            }
            const openAcctRes = await userApi.openAcct(_x);
            if (openAcctRes.error) return;
            if (openAcctRes.code === "0") {
                /* 未注册直接开户需要调用登录接口 */
                if (!this.$store.state.login.status) {
                    setTimeout(async () => {
                        const res = await userApi.login({
                            accttype: "0",
                            logintype: "07",
                            certificatetype: this.pwdForm.certType,
                            certificateno: this.pwdForm.certNo,
                            pwd: this.$util.enc(val.pwd)
                        });
                        this.$cache.setHeadImage(
                            res.data.others.headimage ? res.data.others.headimage : ""
                        );
                        if (res.error) return;
                        this.$cache.setBinded(true);
                        this.$store.dispatch("login", {
                            key: _x.mobileno,
                            ...JSON.parse(sessionStorage.getItem("_a") || "{}"),
                            userinfo: res.data.others,
                            userName: res.data.userName
                        });
                        this.openAcctSuccess();
                    }, 3000);
                } else {
                    setTimeout(() => {
                        this.openAcctAfterUpd(_x);
                        this.$cache.setBinded(true);
                        this.$cache.refreshUser();
                        this.openAcctSuccess();
                    }, 3000);
                }
                this.result.msg = `恭喜您！${this.$const.COMPANY}基金网上交易账户开户成功！`;
            } else {
                this.result.cla = "register-fail";
                this.result.msg = openAcctRes.msg;
            }
        },
        async openAcctAfterUpd(info) {
            await userApi.openAcctAfterUpd({
                mobileno: info.mobileno,
                certificatetype: info.certificatetype,
                certificateno: info.certificateno
            });
        },
        openAcctSuccess() {
            this.navs = [
                { val: "身份验证", active: true },
                { val: "补充资料", active: true },
                {
                    val: "开户结果",
                    active: true
                }
            ];
            this.opentAcct = false;
            this.bindResult = true;
        },
        /* 有效期类型 */
        getvalidtype(date) {
            return date ? (date == "99991231" || date == "长期有效" ? "1" : "0") : "2";
        },
        /* 密码显示或隐藏处理 */
        pwdTypeChange() {
            this.pwdType = this.pwdType === "text" ? "password" : "text";
            this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
        },
        // 账户绑定选项处理
        bindWay(val) {
            this.hasTranAcct = val;
            if (!val) {
                this.navs = [
                    { val: "身份验证", active: true },
                    { val: "补充信息" },
                    { val: "开户结果" }
                ];
            } else {
                this.navs = [
                    { val: "验证身份信息", active: true },
                    { val: "验证交易密码" },
                    { val: "完成绑定" }
                ];
            }
        },
        // 根据身份证号判断性别
        getSex(psidno) {
            let sexno = "";
            if (psidno.length === 18) {
                sexno = psidno.substring(16, 17);
            } else if (psidno.length === 15) {
                sexno = psidno.substring(14, 15);
            } else {
                return false;
            }
            const tempid = sexno % 2;
            return tempid === 0 ? "0" : "1";
        },
        /* 回到首页 */
        findPwd() {
            this.$router.push("/home");
        },
        /* 显示用户信息补充页面 */
        showAcctPage() {
            this.checked = true;
            this.opentAcct = true;
            this.openPar = {
                certType: this.pwdForm.certType,
                address: this.pwdForm.address,
                bankid: this.bankInfo.bankcode,
                isBranch: this.bankInfo.isneedbank,
                custname: this.pwdForm.userName,
                birthdate: this.pwdForm.birthdate
            };
            this.navs = [
                { val: "身份验证", active: true },
                { val: "补充信息", active: true },
                {
                    val: "开户结果"
                }
            ];
        },
        verifyMobileCode(val) {
            this.mobileVisible = false;
            if (val) {
                this.checkVerifyCode(val);
            }
            return false;
        },
        /* 提交表单数据,校验手机验证码 */
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                // if (this.ocrUpdBtnS && this.ocrupdflag == "0") {
                //     this.$message.warning("请先上传有效证件照");
                //     return false;
                // }
                if (valid) {
                    if (!this.hasTranAcct) {
                        if (this.bankInfo.identifytype === "1") {
                            if (!this.locked) {
                                this.$message({
                                    type: "warning",
                                    message: "请先发送手机短信验证码"
                                });
                                return false;
                            }
                        }
                        this.protocol = true;
                    } else {
                        // 查询账户绑定情况
                        this.$util
                            .request("acct/bindtradeacct/status", {
                                certificatetype: this.pwdForm.certType,
                                certificateno: this.pwdForm.certNo,
                                custname: this.pwdForm.userName
                            })
                            .then((res) => {
                                if (res.data) {
                                    // 账户状态0-已绑定 1-未开户 2-已开户
                                    const _x = res.data[0].status;
                                    if (_x === "2") {
                                        this.acctInfo = {
                                            name: res.data[0].custname,
                                            certNo: this.pwdForm.certNo
                                        };
                                        this.checkTPwd = true;
                                        this.checked = true;
                                        this.navs = [
                                            { val: "验证证件信息", active: true },
                                            {
                                                val: "验证交易密码",
                                                active: true
                                            },
                                            { val: "完成绑定", icon: "fa fa-check" }
                                        ];
                                    } else {
                                        this.openTran =
                                            _x === "0"
                                                ? "该交易账号已绑定其他账户"
                                                : "您提供的证件尚未在我司开户";
                                    }
                                }
                            });
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const encNum = this.$util.enc(this.acctInfo.pwd);
                    if (this.hasTranAcct) {
                        this.$util
                            .request("acct/bindtradeacct/bind", { tradepwd: encNum }, "POST")
                            .then((res) => {
                                this.navs = [
                                    { val: "验证证件信息", active: true },
                                    {
                                        val: "验证交易密码",
                                        active: true
                                    },
                                    { val: "完成绑定", icon: "fa fa-check", active: true }
                                ];
                                this.checkTPwd = false;
                                this.bindResult = true;
                                if (res.data) {
                                    this.result.msg =
                                        "您已成功绑定证件号为" +
                                        this.acctInfo.certNo +
                                        "的交易账户";
                                    this.$cache.refreshUser();
                                } else {
                                    this.result.cla = "register-fail";
                                    this.result.msg = res.msg;
                                }
                            });
                        return false;
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 校验手机验证码 */
        async checkVerifyCode(val) {
            // todo
            let param = {
                biztype: "03",
                smscode: val,
                mobileno: this.pwdForm.mobile
            };
            const res = await userApi.checkBindCardSms(param);
            if (res.code === "0") {
                this.showAcctPage();
            }
        },
        /* 显示银行卡列表弹框 */
        showBank() {
            this.bankVisible = !this.bankVisible;
        },
        /* 回调银行卡信息 */
        getBankMsg(val) {
            this.bankVisible = false;
            if (val && val.bank) {
                this.bankInfo = val.bank;
                this.pwdForm.bankType = this.bankInfo.channelid;
                // this.bankInfo.hkopenflag = this.bankInfo.hkopenflag;
            }
        },
        /* 校验用户姓名 */
        checkName(rule, value, callback) {
            if (this.dis) {
                callback();
            } else {
                if (this.$util.isEmpty(value)) {
                    if (this.pwdForm.certType == "00" && this.hasOcr == "1") {
                        callback(new Error("请上传证件获取姓名"));
                    } else {
                        callback(new Error("请输入姓名"));
                    }
                } else {
                    this.$util.validateName(rule, value, callback);
                }
            }
            callback();
        },
        /* 校验证件号码 */
        checkCertNo(rule, value, callback) {
            if (this.dis) {
                callback();
            } else {
                if (this.$util.isEmpty(value)) {
                    if (this.pwdForm.certType == "00" && this.hasOcr == "1") {
                        callback(new Error("请上传证件获取证件号码"));
                    } else {
                        callback(new Error("请输入证件号码"));
                    }
                } else {
                    this.$util.validateCertNo(rule, value, callback, this.pwdForm.certType);
                }
            }
            callback();
        },
        checkVailddate(rule, value, callback) {
            if (this.$util.isEmpty(value)) {
                if (this.pwdForm.certType == "00" && this.hasOcr == "1") {
                    callback(new Error("请上传证件获取证件有效期"));
                } else {
                    callback(new Error("请选择证件有效期"));
                }
            }
            callback();
        },
        checkBirthdate(rule, value, callback) {
            if (this.$util.isEmpty(value)) {
                if (this.pwdForm.certType == "00" && this.hasOcr == "1") {
                    callback(new Error("请上传证件获取出生日期"));
                } else {
                    callback(new Error("请选择出生日期"));
                }
            }
            callback();
        },
        /* 提交表单数据 */
        async mobileCheck() {
            if (this.hasTranAcct) {
                this.submitForm("pwdForm");
                return;
            }
            if (this.ocrUpdBtnS && this.ocrupdflag == "0") {
                if (this.pwdForm.certType == "00") {
                    this.$message.warning("请先上传有效证件照");
                }
                return false;
            }
            if (this.$cache.getCompanyInfoParam("100047") == "0") {
                const _date = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
                if (Number(this.pwdForm.birthdate) >= Number(_date)) {
                    this.$alert("根据您的证件信息，您属于未成年人，暂时无法开户！", "温馨提示");
                    return false;
                }
            }
            // /*自然人联网查询 只支持身份证*/
            if (
                this.pwdForm.certType == "00" &&
                !this.$cache.getCompanyInfoParam("10301003").includes("AA9")
            ) {
                const res = await userApi.combPersonAuth({
                    relationname: this.pwdForm.userName,
                    certificateno: this.pwdForm.certNo,
                    certificatetype: this.pwdForm.certType,
                    invtp: "1",
                    relationtype: "0",
                    validdate: this.pwdForm.vailddate
                });
                if (res.error) return;
                if (res.data.status !== "1") {
                    this.$alert(res.data.message, "温馨提示");
                    return false;
                }
            }
            let mes = "";
            // 处理银行卡找回密码表单数据校验
            if (this.checkBank || (!this.hasTranAcct && this.hasTranAcct !== undefined)) {
                for (const key in this.pwdForm) {
                    if (key !== "verifyCode" && key !== "type") {
                        this.$refs["pwdForm"].validateField(key, function (str) {
                            if (str) {
                                mes = str;
                                return false;
                            }
                        });
                    }
                }
            }
            if (mes !== "") {
                return false;
            }
            this.sendBank();
        },
        /* 银行卡鉴权发送鉴权信息 */
        async sendBank(val = "") {
            let data = {
                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo,
                custname: this.pwdForm.userName,
                mobileno: this.pwdForm.mobile,
                depositcard: this.pwdForm.bankNo,
                channelid: this.bankInfo.channelid,
                channelname: this.bankInfo.channelname,
                biztype: "03"
                // verifycode: val
            };
            if (this.bankInfo.identifytype === "1") {
                /* 短信鉴权 */
                const res = await userApi.sendBindCardSms(data);
                if (res.code === "0") {
                    this.mobileVisible = true;
                }
            } else if (this.bankInfo.identifytype === "2") {
                /* 页面鉴权 */
                this.randomToken = this.generateRandomNumber();
                const res = await userApi.combSignApply({
                    ...data,
                    pagecallbackurl:
                        this.$util.getConfig().api.v5BaseUrl +
                        "/bank/redirect?token=" +
                        this.randomToken,
                    signtype: "0",
                    bankcode: this.bankInfo.bankcode,
                    depositname: this.pwdForm.userName,
                    paychannel: this.bankInfo.paycenterid
                });
                if (res.data) {
                    const pageUrl = res.data.bankgateurl ? res.data.bankgateurl : "";
                    let pageParam = res.data.bankgateparam ? res.data.bankgateparam : {};
                    if (pageParam) {
                        pageParam = JSON.parse(pageParam);
                    }
                    const bankgateserialno = res.data.bankgateserialno;
                    this.$util.openPostWindow(pageUrl, pageParam, "_blank");
                    const params = {
                        token: this.randomToken,
                        certificatetype: this.pwdForm.certType,
                        certificateno: this.pwdForm.certNo,
                        bankcode: this.bankInfo.bankcode,
                        depositcard: this.pwdForm.bankNo,
                        depositname: this.$cache.getUser().custname,
                        mobileno: this.pwdForm.mobile,
                        paychannel: this.bankInfo.paycenterid,
                        bankgateserialno: bankgateserialno,
                        signtype: "0"
                    };
                    this.$util.confirmBankAuth(this, params, "BankPageAuthentication", () => {
                        // this.getSuccessInfo();
                        this.showAcctPage();
                    });
                }
            }
        },
        // 处理银行卡操作成功信息-不需要 TODO
        getSuccessInfo() {
            // 用户首次增卡更新
            if (this.fn) {
                const info = this.$cache.getUser();
                info.totalcardnum = Number(info.totalcardnum) + 1;
                this.$store.dispatch("setInfo", info).then(() => {
                    this.$emit("fn-back", true);
                });
            } else {
                // 绑定交易账户后更新
                this.$cache.refreshUser();
                this.result.msg = "您的银行卡已" + this.cateText + "成功！";
                const _num = this.acctInfo.bankcard
                    ? this.acctInfo.bankcard
                    : this.acctInfo.oldBank;
                this.result.btnMsg =
                    "您" +
                    this.cateText +
                    "的银行卡为：" +
                    this.$cache.getDict("110080", this.bankInfo.bankcode) +
                    "(" +
                    this.$cache.getDict("110079", this.bankInfo.paycenterid) +
                    ")尾号[" +
                    _num.substr(_num.length - 4, 4) +
                    "]";
                this.checked = true;
            }
        },
        generateRandomNumber() {
            let randomNum = "";
            while (randomNum.length < 16) {
                randomNum += Math.floor(Math.random() * 10).toString();
            }
            return randomNum;
        },
        imgUp(flag) {
            this.ocrupdflag = "1";
            this.dateSet.dis = true;
            this.dateSetBirth.dis = true;
            if (flag) {
                this.pwdForm.certNo = flag.certificateno;
                this.pwdForm.userName = flag.custname;
                this.pwdForm.vailddate = flag.vailddate;
                // this.pwdForm.birthdate = flag.birthday;
                this.pwdForm.address = flag.address;
                this.pwdForm.sex = flag.sex;
            }
            this.dateSet.val = this.$util.fmtDate(this.pwdForm.vailddate);
            // this.dateSetBirth.val = this.$util.fmtDate(this.pwdForm.birthdate);
            this.initBirthdate(); /* 从证件号截取 */
        },
        regression() {
            this.ocrShow = false;
        },
        /* 返回上一页 */
        backPage() {
            this.$router.push({ name: "home" });
        },
        dateInterval(val) {
            this.pwdForm.vailddate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.pwdForm.validateField("vailddate");
        },
        dateInterval_birth(val) {
            this.pwdForm.birthdate = val !== null ? val.replace(/-/g, "") : "";
        },
        getOcrOpenStatus() {
            this.ocrEnable = this.ocrEnable = this.$cache
                .getCompanyInfoParam("88202302")
                .includes("A84");
            this.dis = this.ocrEnable;
        },
        initBirthdate() {
            // 身份证
            if (this.pwdForm.certType === "00" || this.pwdForm.certType === "05") {
                const sIdNo = this.pwdForm.certNo;
                const that = this;
                that.$util.validateCertNo(
                    "",
                    sIdNo,
                    function () {
                        if (sIdNo.length === 15) {
                            that.pwdForm.birthdate = "19" + sIdNo.substr(6, 6);
                        } else if (sIdNo.length === 18) {
                            that.pwdForm.birthdate = sIdNo.substr(6, 8);
                        }
                        that.$set(
                            that.dateSetBirth,
                            "val",
                            that.$util.fmtDate(that.pwdForm.birthdate, "-")
                        );
                    },
                    "0"
                );
            }
        },
        async getCrmCustInfo() {
            const info = this.$cache.getUser();
            if (info.mobileno) {
                this.pwdForm.mobile = info.mobileno;
            }
            if (info.custbelongto !== "2" || !info.custnoCrm) return;
            const res = await userApi.qryCrmCustInfo({ custnoCrm: info.custnoCrm });
            if (res.data && res.data.certificatetype === "00") {
                this.pwdForm.userName = res.data.custname;
                this.pwdForm.certNo = res.data.certificateno;
                this.pwdForm.validdate = res.data.validdate || "";
                this.initBirthdate();
                if (res.data.birthdate !== "") {
                    this.pwdForm.birthdate = res.data.birthdate;
                }
                this.crmCustInfo = res.data;
            }
        },
        // 生成搜索列表
        querySearch(queryString, cb) {
            let cityObj = this.city.find((item) => {
                return item.cityid === this.pwdForm.city;
            });
            this.pwdForm.cityName = cityObj.cityname;
            this.$util.querySearch(this, queryString, this.bankInfo.bankcode, cb, "pwdForm");
        },
        checkBankName() {
            const _y = this.branchList.filter((branch) => {
                return branch.branchname === this.pwdForm.bankname;
            });
            if (_y.length === 0) {
                this.$set(this.pwdForm, "bankname", "");
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.check-acct {
    margin-top: 18px;
}
.comp-bind-acct-dc {
    .acct-con {
        padding: 20px;
        .cert-types-line {
            margin-top: 30px;
            margin-left: 252px;
            > .el-form-item__content {
                > .el-select {
                    padding-right: 2%;
                }
                > .el-button {
                    width: 96px;
                    height: 40px;
                    font-size: 16px;
                    text-align: center;
                    padding: 0 8px;
                }
            }
        }
        .investor-data-up {
            margin-top: 20px;
        }
        .cant-info {
            text-align: center;
            font-size: 18px;
            color: #333333;
            line-height: 30px;
            margin: 20px auto;
        }
        .cant-up {
            margin: 30px auto;
            width: 100%;
            text-align: center;
        }
        .birthdate-select .el-checkbox.date-check {
            display: none;
        }
    }

    ::v-deep(.el-form-item) {
        .el-form-item__label {
            font-size: $f14;
            color: $text-color2;
        }
        .el-input {
            font-size: $f16;
            width: 400px;
        }
        .el-select {
            width: 400px;
        }
        .el-input__inner {
            border-radius: 2px;
        }
    }
    .form-mobile,
    .form-bankInfo {
        ::v-deep(label.el-form-item__label) {
            width: 150px !important;
        }
    }
    .ocrTip {
        text-align: center;
        font-size: 18px;
        color: #999;
        margin-bottom: 23px;
    }
    .cut-off-line {
        margin-top: 8px;
    }
    .bank-info {
        margin-left: 252px;
    }
    .el-button.info-btn {
        border: none;
        padding: 12px 10px;
        &:hover,
        &:focus {
            background-color: transparent;
        }
    }
    .form-row-mobile,
    .form-bankInfo {
        margin-left: 212px;
    }
    .bank-btn {
        margin-top: 49px;
        margin-left: 250px;
        .el-button {
            width: 180px;
        }
        .el-button:nth-child(2) {
            margin-left: 40px;
        }
    }
}
.open-acct-result {
    margin: 48px 250px 40px;
    text-align: center;
    .result-contain {
        width: 660px;
        height: 242px;
        border-radius: 6px;
        background: #f9f9f9;
        margin-bottom: 30px;
        .result-text {
            font-size: 26px;
            font-weight: 500;
            line-height: 26px;
            margin: 23.8px 0 14px;
        }
        .res-text {
            font-size: 18px;
            line-height: 28px;
            font-weight: normal;
            color: $bg18;
        }
    }
    .result-confirm-contain {
        width: 660px;
    }
}
.footer-questions {
    margin-top: 21px;
}
</style>
